<template>
    <div>
        <el-popover
            placement="bottom"
            :width="350"
            trigger="click"
            v-model:visible="dateRangeFilterVisible"
        >
            <template #reference>
                <el-button
                    ><i class="el-icon-date"></i> {{ dateRange[0] | date }} -
                    {{ dateRange[1] | date }}</el-button
                >
            </template>

            <div class="flex flex-column gap">
                <el-button
                    @click="selectDateRange('YESTERDAY')"
                    v-bind:class="{
                        'is-active': dateRangeActive === 'YESTERDAY',
                    }"
                    >Yesterday</el-button
                >
                <el-button
                    @click="selectDateRange('LAST_SEVEN_DAYS')"
                    v-bind:class="{
                        'is-active': dateRangeActive === 'LAST_SEVEN_DAYS',
                    }"
                    >Last 7 days</el-button
                >
                <el-button
                    @click="selectDateRange('LAST_30_DAYS')"
                    v-bind:class="{
                        'is-active': dateRangeActive === 'LAST_30_DAYS',
                    }"
                    >Last 30 days</el-button
                >
                <el-button
                    @click="selectDateRange('LAST_MONTH')"
                    v-bind:class="{
                        'is-active': dateRangeActive === 'LAST_MONTH',
                    }"
                    >Last Month</el-button
                >

                <el-date-picker
                    v-model="dateRangePicker"
                    type="daterange"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    format="d.M.yyyy"
                    :picker-options="datePickerOptions"
                />
            </div>
        </el-popover>
    </div>
</template>

<script>
export default {
    name: 'v-custom-date-range-picker',

    data() {
        return {
            dateRange: [],
            dateRangePicker: [],
            dateRangeFilterVisible: false,
            dateRangeActive: '',
            datePickerOptions: {
                disabledDate(date) {
                    return (
                        date > new Date() ||
                        date <
                            new Date(
                                Date.now() - 20 * 365 * 24 * 60 * 60 * 1000
                            )
                    ); // range between last 20 years and today
                },
            },
        };
    },

    mounted() {
        this.selectDateRange('LAST_30_DAYS');
    },

    watch: {
        dateRange() {
            this.$emit('dateRange', this.dateRange);
        },

        dateRangePicker() {
            if (this.dateRangePicker) {
                this.dateRange = this.dateRangePicker;
                this.dateRangeActive = null;
                this.dateRangeFilterVisible = false;
            }
        },
    },

    methods: {
        selectDateRange(type) {
            let date = new Date(Date.now() - 24 * 60 * 60 * 1000);
            this.dateRangeActive = type;

            switch (type) {
                case 'YESTERDAY':
                    this.dateRange = [date, date];
                    break;

                case 'LAST_SEVEN_DAYS':
                    date = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
                    this.dateRange = [date, new Date()];
                    break;

                case 'LAST_30_DAYS':
                    date = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
                    this.dateRange = [date, new Date()];
                    break;

                case 'LAST_MONTH':
                    const startDate = new Date();
                    startDate.setDate(1);
                    startDate.setMonth(startDate.getMonth() - 1);
                    const endDate = new Date();
                    endDate.setDate(0);
                    endDate.setMonth(endDate.getMonth());
                    this.dateRange = [startDate, endDate];
                    break;
            }

            this.dateRangeFilterVisible = false;
        },
    },
};
</script>

<style scoped>
.flex {
    display: flex;
}

.flex-column {
    flex-direction: column;
}

.flex-column .el-button {
    margin-left: 0 !important;
}

.gap {
    gap: 20px;
}
</style>



// WEBPACK FOOTER //
// CustomDateRangePicker.vue?6c25e2d5